<template>
  <div class="industrial-internet">
    <div class="solution-banner">
      <img src="@/assets/images/website/solution/industrial-internet/banner.png" />
    </div>
    <div class="industrial-internet-introduce">
      <div class="website-container">
        <img alt src="@/assets/images/website/solution/industrial-internet/part_1.png" />
        <img alt src="@/assets/images/website/solution/industrial-internet/part_2.png" />
        <img alt src="@/assets/images/website/solution/industrial-internet/part_3.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style lang="less" scoped>
.solution-banner {
  width: 100%;
  img {
    width: 100%;
    object-fit: cover;
  }
}
.industrial-internet-introduce {
  img {
    width: 100%;
    margin: 20px 0;
  }
}
</style>
